module.exports = __webpack_public_path__ + "media/images/lb/832-1da0fb07dcaf71a1537145e4535f4a05.svg";